'use strict';

exports.__esModule = true;
exports.tfn = undefined;

var _zhCN = require('./zh-CN.js');

var _zhCN2 = _interopRequireDefault(_zhCN);

var _util = require('../_util/util.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tfn = exports.tfn = function tfn(path) {
  return (0, _util.getValueByPath)(_zhCN2.default, path, '');
};

exports.default = { tfn: tfn };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bic-fe/mds-ui/dist/_locale/index.js
// module id = Gemk
// module chunks = 0